import { Badge, Card, Group, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { MatchIndicators } from "../components/MatchIndicators";
import { PreferredLocationsDisplay } from "../components/PreferredLocationsDisplay";
import { PreferredTimesDisplay } from "../components/PreferredTimesDisplay";
import { PersonalityTestSection } from "../StagingGroupCard/PersonalityTestSection";
import { CurrentReservationDisplayProps, formatTime } from "./types";

export const CurrentReservationDisplay = ({
  request,
  currentEventTime,
  currentEventLocation,
}: CurrentReservationDisplayProps) => {
  const [showPersonalityTest, setShowPersonalityTest] = useState(false);

  // Calculate matches with current event
  const dateMatches = request.preferredTimes.some((time) => {
    const timeString = typeof time === "string" ? time : (time as Date).toISOString();
    const preferredDate = new Date(timeString).toISOString();
    const eventDate = new Date(currentEventTime).toISOString();
    return preferredDate === eventDate;
  });

  const locationMatches = request.preferredLocations.some(
    (loc) => loc.name === currentEventLocation
  );

  // Status badge
  const statusColors: Record<string, string> = {
    PENDING: "#ffaf5b",
    CONFIRMED: "#20c24a",
    CANCELLED: "#b6442e",
    CANCELLED_NO_REFUND: "#b6442e",
    CHANGE_REQUESTED_BY_ADMIN: "#ca5040",
    PREFERENCE_OVERRIDE_REQUESTED: "#ca5040",
  };

  const statusLabels: Record<string, string> = {
    PENDING: "큐레이션 중",
    CONFIRMED: "초대 확정",
    CANCELLED: "예약 취소",
    CANCELLED_NO_REFUND: "예약 취소",
    CHANGE_REQUESTED_BY_ADMIN: "변경 제안",
    PREFERENCE_OVERRIDE_REQUESTED: "일정 변경 제안",
  };

  const color = statusColors[request.status] || "#20c24a";
  const label = statusLabels[request.status] || request.status;

  return (
    <Card withBorder padding="lg" radius="md" mb="md">
      <Stack gap="md">
        <div>
          <Text size="sm" c="dimmed" mb="xs">
            현재 예약 정보
          </Text>
          <Group gap="xs" mb={4}>
            <Text c="black" size="md" fw={600}>
              {request.user.name} ({request.user.nickname})
            </Text>
            <Badge size="sm" style={{ backgroundColor: color, color: "white" }}>
              {label}
            </Badge>
          </Group>
          <MatchIndicators dateMatches={dateMatches} locationMatches={locationMatches} />
        </div>

        <PreferredTimesDisplay
          preferredTimes={request.preferredTimes.map((t) =>
            typeof t === "string" ? t : (t as Date).toISOString()
          )}
          formatTime={formatTime}
          selectedDate={currentEventTime}
        />

        <PreferredLocationsDisplay
          preferredLocations={request.preferredLocations}
          selectedLocationId={null}
          selectedLocationName={currentEventLocation}
        />

        <PersonalityTestSection
          requestId={request.id}
          answers={request.user.personalityTestAnswers}
          isVisible={showPersonalityTest}
          onToggle={() => setShowPersonalityTest(!showPersonalityTest)}
        />
      </Stack>
    </Card>
  );
};
